<template>
  <div class="organization-locations-tab">
    <v-row>
      <v-col cols="12">
        <v-card :loading="organizationLocationsLoading || locationsLoading">
          <v-card-title>Available Locations</v-card-title>
          <v-card-text>
            <v-treeview
              selected-color="primary"
              :items="nestedLocations ? nestedLocations: []"
              item-children="locations"
              item-text="label"
              item-key="uuid"
              hoverable
              rounded
            >
              <template v-slot:prepend="{ item }">
                <v-icon
                  v-if="item.locations ? item.locations.length : false"
                  :color="organizationLocationsUuids.includes(item.uuid) ? 'primary':'grey'"
                >flag</v-icon>
                <v-icon
                  v-else
                  :color="organizationLocationsUuids.includes(item.uuid) ? 'primary':'grey'"
                >restaurant</v-icon>
              </template>
              <template v-slot:append="{ item }">
                <v-btn
                  color="primary"
                  small
                  rounded
                  @click="openLocation(findLocation(item))"
                  :disabled="!organizationLocationsUuids.includes(item.uuid)"
                >
                  <v-icon left small>people</v-icon>
                  <span>Manage Users</span>
                </v-btn>
              </template>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import mixin from "@/mixins";
export default {
  mixins: [mixin],
  props: {
    organizationLocations: { type: Array, required: true },
    locations: { type: Array, required: true },
    nestedLocations: { type: Array, required: true },
    organizationLocationsLoading: { type: Boolean, required: true },
    locationsLoading: { type: Boolean, required: true }
  },
  data() {
    return {
      alert: false
    };
  },
  computed: {
    importedLocations() {
      return this.locations.filter(location =>
        this.organizationLocationsUuids.includes(location.uuid)
      );
    },
    organizationLocationsUuids() {
      return this.organizationLocations.map(location => location.uuid);
    }
  },
  methods: {
    openLocation(location) {
      this.$emit("openLocation", location);
    },
    findLocation(location) {
      return this.organizationLocations.find(loc => loc.uuid == location.uuid);
    }
  }
};
</script>

<style>
</style>